import React from 'react'
import AlbumItem from '../components/AlbumItem';

export default function AlbumList({ homePath, albums, selectedAlbum, handleClick }) {
    return (
        <div className='bg-gray-900 rounded-lg min-h-[calc(90vh)] w-75 mt-2'>
            <div className='h-[calc(88vh)] overscroll-contain overflow-x-hidden overflow-y-auto touch-pan-y'>
                {albums.map((album, index) => (
                    <div key={album.id} 
                        className={`flex-1 items-center justify-center overflow-hidden transition-all duration-300 hover:scale-103 mb-4
                            ${index === selectedAlbum
                                ? 'bg-gray-700 rounded-lg'
                                : ''
                            }`}
                        onClick={handleClick.bind(null, index)}
                    >
                        <div>
                            <AlbumItem
                                homePath={homePath}
                                albumCode={album.album_code}
                                fileName={album.cover_item}
                            />
                            <div>
                                <div className='flex justify-between -mt-2'>
                                    <label className="pl-4 text-orange-300 truncate text-nowrap">
                                        {album.title}
                                    </label>
                                </div>
                                <div className='-mt-2'>
                                    <label className="pl-4 text-orange-300 text-nowrap text-xs">
                                        {album.created_at.slice(0, 10)}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
